module.exports = __webpack_public_path__ + "static/media/adv_img_5.0626a6cd.jpg";